var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrustWalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3A78FF",
    d: "m23.047 2.66 1.016-1.313a1.66 1.66 0 0 0-2.032 0l1.016 1.313Zm17.41 5.114 1.66.027a1.66 1.66 0 0 0-1.66-1.687v1.66ZM23.046 43.34l-.92 1.382a1.658 1.658 0 0 0 1.84 0l-.92-1.382ZM5.664 7.774v-1.66A1.662 1.662 0 0 0 4.004 7.8l1.66-.027ZM22.03 3.973c7.537 5.839 16.16 5.463 18.426 5.463V6.114c-2.343 0-9.857.296-16.392-4.767L22.03 3.973Zm16.766 3.774c-.124 7.714-.452 13.156-1.076 17.187-.617 3.989-1.499 6.379-2.634 8.058-1.15 1.744-2.597 2.78-4.731 4.057-2.157 1.291-4.881 2.683-8.228 4.907l1.84 2.765c3.184-2.122 5.84-3.474 8.093-4.822 2.273-1.362 4.27-2.861 5.778-5.047 1.521-2.25 2.51-5.183 3.16-9.41.646-4.186.989-9.853 1.116-17.64l-3.318-.055Zm-14.83 34.209c-3.347-2.224-6.07-3.612-8.223-4.907-2.136-1.276-3.576-2.312-4.723-4.056-1.129-1.678-2.011-4.063-2.627-8.058-.623-4.032-.948-9.474-1.073-17.188L4 7.801c.128 7.789.468 13.455 1.112 17.64.651 4.227 1.638 7.16 3.16 9.41 1.503 2.186 3.5 3.686 5.77 5.048 2.25 1.347 4.904 2.7 8.09 4.822l1.835-2.765ZM5.66 9.436c2.243 0 10.867.376 18.4-5.463l-2.032-2.626C15.492 6.41 7.978 6.114 5.66 6.114v3.322Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustWalletLogo);
export default __webpack_public_path__ + "static/media/trustWalletLogo.8f1fe2a57653a5e5bff6da49bd68f494.svg";
export { ForwardRef as ReactComponent };